/* Whether an error means the user said no in their wallet — rejected a
 * transaction, a signature or a network switch. Walks the `cause` chain, since
 * viem and the Li.Fi SDK each wrap the wallet's error in one of their own.
 *
 * 4001 is EIP-1193's "user rejected", and 1007 is the Li.Fi SDK's
 * SignatureRejected, which it throws in place of the wallet's error.
 */
const REJECTED_CODES = [4001, 1007];
const REJECTED_NAMES = ["UserRejectedRequestError"];
const REJECTED_TEXT = /user (rejected|denied|cancel)|rejected by user|request rejected/i;

export const isUserRejection = (err) => {
    for (let e = err, depth = 0; e && depth < 10; e = e.cause, depth += 1) {
        if (REJECTED_CODES.includes(e.code)) return true;
        if (REJECTED_NAMES.includes(e.name)) return true;
        if (REJECTED_TEXT.test(e.shortMessage || e.message || "")) return true;
    }
    return false;
};

/* The Li.Fi SDK rethrows a rejection out of a promise nobody awaits, even
   though the widget has already shown the failure and offered a retry. Without
   this the browser logs it as unhandled, and in development the dev server
   covers the page with its error overlay. Registered in the capture phase so
   it runs before the dev server's own listener and can stop it. */
export const ignoreUnhandledUserRejections = () => {
    window.addEventListener(
        "unhandledrejection",
        (event) => {
            if (!isUserRejection(event.reason)) return;
            event.preventDefault();
            event.stopImmediatePropagation();
        },
        true,
    );
};
